module.exports = __webpack_public_path__ + "img/performance.48dd2162.png";